export const columns = (vm) => {
  return [
    {
		type: 'selection',
		align:"center",
		headerAlign:"center",
		width:60,
	  },
      {
          prop: 'name',
          label: '联动名称',
          minWidth: '120',
          tooltip: true
      },
      {
          prop: 'name',
          label: '操作人员',
          minWidth: '120',
          tooltip: true
      },
      {
          prop: 'name',
          label: '更新时间',
          minWidth: '120',
          tooltip: true
      },
      {
          label: '操作',
          fixed: 'right',
          width: 160,
          render: (h, params) => {        

            let setup = (h)=>h('el-button', {
                props: {
                    type: 'text',
                },
                style: {
                    padding: 0,
                },
                on: {
                    click: () => {
                        vm.operateShow('0', params.row);
                    }
                }
            }, '设置');

            let query = (h)=>h('el-button', {
                props: {
                    type: 'text',
                },
                style: {
                    padding: 0,
                },
                on: {
                    click: () => {
                        vm.operateShow('1', params.row);
                    }
                }
            }, '查看');

            let del = (h)=>h('el-button', {
                props: {
                    type: 'text',
                },
                style: {
                    padding: 0,
                },
                on: {
                    click: () => {
                        vm.operateShow('2', params.row);
                    }
                }
            }, '删除');

            let btnArr = [];

            // btnArr.push(setup(h));
            btnArr.push(query(h));
            // btnArr.push(del(h));

            return h('div',{},btnArr)
          }
      }
  ]
}